import { useMemo } from "react";
import ReactImageMagnify from 'react-image-magnify';
import { FlagRegionByIso } from "components/Function";

const useColumnTableProductLive = (heightRow = 100) => {
    const columns = useMemo(() => {
        return [
            {
                field: "_id",
                headerName: "",
                sortable: false,
                editable: false,
                cellClass: "centered-cell",
                width: 10,
                cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            },
            {
                field: "live_data",
                headerName: "Live Stream",
                sortable: false,
                editable: false,
                autoHeight: true,
                cellClass: "overflow-visible",
                width: 300,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4" style={{ height: heightRow - 1 + "px" }}>
                        <div className="symbol symbol-60px symbol-lg-80px symbol-fixed position-relative me-3">
                            {/* <Link to={row.cover_url} target="_blank"> */}
                                <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: row.cover_url }, largeImage: { src: row.cover_url, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 }, imageClassName: "overflow-hidden al-border-radius-8" }} />
                            {/* </Link> */}
                        </div>
                        <div
                            className="d-flex flex-column lh-lg gap-2"
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                data-tooltip-id="my-tooltip"
                                data-tooltip-html={`<div style="width: 200px">${row.live_title}</div>`}
                                className="mb-0 fw-bold"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                {row.live_title}
                            </span>
                        </div>
                    </div>
                ),
            },
            {
                field: "influencer",
                headerName: "Creator",
                cellClass: "centered-cell bt-content-fit",
                sortable: false,
                width: 250,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="d-flex align-items-center p-4 w-100" style={{ height: heightRow - 1 + "px" }}>
                        <div className="symbol symbol-45px symbol-circle">
                            <img
                                src={row.influencer.avatar_url}
                                alt=""
                                className="me-3"
                                style={{ width: 20, height: 20, objectFit: "cover" }}
                            />
                        </div>
                        <div
                            className="d-flex flex-column lh-lg gap-2 w-100px"
                            style={{
                                overflow: "hidden",
                                flex: "1",
                            }}
                        >
                            <span
                                className="mb-0 fw-bold"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: "1",
                                }}
                            >
                                {row.influencer.unique_id}
                            </span>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {row.influencer.region?.key ? (
                                    <FlagRegionByIso name={row.influencer.region.name} iso={row.influencer.region.key} />
                                ) : (
                                    ""
                                )}
                            </div>
                            <span
                                className="mb-0 text-gray-500"
                            >
                                Followers: {row.influencer.follower_count}
                            </span>
                        </div>
                    </div>
                ),
            },
            {
                field: "live_time",
                headerName: "Live Time",
                cellClass: "centered-cell",
                sortable: false,
                width: 300,
                cellRenderer: ({ data: row, cell }) => (
                    <div className="w-100">
                        <p className="mb-0">Start Time: {row.start_time}</p>
                        <p className="mb-0">End Time: {row.end_time}</p>
                        <p className="mb-0">duration: {row.duration}</p>
                    </div>
                ),
            },
            {
                field: "per_views_avg_cnt",
                headerName: "Watch PV",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "viewers_peak",
                headerName: "AudiencePeak",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "total_product_cnt",
                headerName: "NumberOfSku",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "product_gmv_amt",
                headerName: "GMV",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "product_sale_cnt",
                headerName: "Sales",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "gmv",
                headerName: "Estimated GMV",
                cellClass: "centered-cell",
                sortable: false,
            },
            {
                field: "publish_time",
                headerName: "Publish Time",
                cellClass: "centered-cell",
                sortable: false,
            },
            // {
            //     field: "-",
            //     headerName: "Actions",
            //     editable: false,
            //     cellClass: "centered-cell",
            //     width: 140,
            //     // pinned: "right",
            //     cellRenderer: ({ data: row }) => (
            //         <>
            //             <Link
            //                 role="button"
            //                 to={`/admin/spy-advanced/products/${row.product_id}`}
            //                 className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
            //                 data-tooltip-id="my-tooltip"
            //             >
            //                 <i className="fa fa-search fs-2"></i>
            //             </Link>
            //         </>
            //     ),
            // },
        ];
    }, [heightRow]);

    return columns;
};

export default useColumnTableProductLive;
